import { DOCUMENT } from '@angular/common';
import type { Renderer2 } from '@angular/core';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProductPickerService {
  regExp = /\[productPicker(?:\s+data="([^"]*)")?\]/g;
  renderer: Renderer2;

  constructor(@Inject(DOCUMENT) public document: Document) {}

  /**
   * setRendererForProductPicker sets renderer from the target template
   *
   * @param {Renderer2} renderer - renderer
   */
  setRendererForProductPicker = (renderer: Renderer2) => {
    this.renderer = renderer;
  };

  /**
   * productPickerParser replaces [productPicker] shortcodes with HTML placeholders
   * that will be dynamically replaced with the actual Angular component
   * Supports optional data attribute: [productPicker data="dataKey"]
   *
   * @param {string} content - HTML content containing [productPicker] shortcodes
   * @return {string} - HTML content with placeholders instead of shortcodes
   */
  productPickerParser = (content: string): string => {
    if (content && typeof content === 'string') {
      const productPickerInstances = [...content.matchAll(this.regExp)];

      // No productPicker shortcode found, return unmodified content
      if (!productPickerInstances.length) {
        return content;
      }

      // Replace each [productPicker] shortcode with a placeholder div
      productPickerInstances.forEach((instance, index) => {
        const dataKey = instance[1] || null; // Extract data key if provided
        const uniqueId = `product-picker-${Date.now()}-${index}`;
        const dataAttribute = dataKey ? ` data-key="${dataKey}"` : '';
        const productPickerHtml = `<div id="${uniqueId}" class="product-picker-placeholder" data-component="productPicker"${dataAttribute}></div>`;

        // Replace the shortcode with the placeholder HTML
        content = content.replace(instance[0], productPickerHtml);
      });
    }

    return content;
  };
}